import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import classNames from 'classnames/bind';
import styles from 'features/home/index.module.sass';
import LeftBar from 'componets/leftbar';
import FixTopContainer from 'componets/fix-top-container';
import Navbar from 'componets/navbar';
import { AnnouncementBoard } from 'componets/announcement-board';
import Profile from 'features/profile';
import Drivers from 'features/drivers';
import LicensePlates from 'features/licenese-plates';
import Payment from 'features/payment';
import Orders from 'features/orders';
import Stats from 'features/stats';
import Coupon from 'features/coupon';
import Points from 'features/points';
import { useAppContext } from 'use-app';
import PageNotFound from 'componets/page-not-found';
import { PATH } from 'config/path';
import { LINE_URL } from 'config/config';
import OuterLink from 'componets/outer-link';
import analytics from 'service/analytics';
import { Helmet } from 'react-helmet';
import { AppLineappIcon } from 'icons';
import useDevice, { DEVICE_MOBILE } from 'hooks/use-device';

const cx = classNames.bind(styles);

const LineButton = () => {
  return (
    <OuterLink link={LINE_URL} classname={styles.line} onClick={() => analytics.track('LINE客服_click')}>
      <AppLineappIcon width={20} height={20} />
      聯繫客服
    </OuterLink>
  );
};

const Home = () => {
  const { fetchUserInfo, state } = useAppContext();
  const device = useDevice();
  const isMobile = device === DEVICE_MOBILE;
  const isAccountBalanceLow = (state.me?.currentCreditCard?.debitAccounts ?? []).some(item => item.balanceLow);

  let announcementAlertType = undefined;

  if (!state.hasPayments) {
    announcementAlertType = 'no_payment';
  } else if (!state.hasLicensePlates) {
    announcementAlertType = 'no_license_plate';
  } else if (isAccountBalanceLow) {
    announcementAlertType = 'balance_low';
  }

  useEffect(() => {
    document.body.style.overflow = 'inherit';
    window.scrollTo(0, 0);
    fetchUserInfo();
  }, []); //eslint-disable-line

  return (
    <>
      <Helmet>
        <title>企業管理後台｜Autopass for Business</title>
      </Helmet>
      <FixTopContainer>
        <Navbar />
        {!isMobile && <AnnouncementBoard alertType={announcementAlertType} />}
      </FixTopContainer>
      <LineButton />
      <div className={styles.wrapper}>
        <div
          className={cx('container', {
            'with-announcement': !isMobile && announcementAlertType,
          })}
        >
          <LeftBar announcementBoard={isMobile && <AnnouncementBoard alertType={announcementAlertType} />} />
          <Switch>
            <Route exact path={PATH.PROFILE} component={Profile} />
            <Route exact path={PATH.DRIVERS} component={Drivers} />
            <Route exact path={PATH.LICENSE_PLATES} component={LicensePlates} />
            <Route path={PATH.PAYMENT} component={Payment} />
            <Route path={PATH.ORDERS} component={Orders} />
            <Route exact path={PATH.STATS} component={Stats} />
            <Route exact path={PATH.COUPON} component={Coupon} />
            <Route exact path={PATH.POINTS} component={Points} />
            <Route path="*" component={PageNotFound} />
          </Switch>
        </div>
      </div>
    </>
  );
};

export default Home;
